import breadcrumbImage from "../../assets/images/course/cousre.jpg";
import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import AboutImage from "../../assets/images/feature/about.png";
import { motion } from "framer-motion";
// import { HiBadgeCheck } from "react-icons/hi";

const AboutUs = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
const [bgImage, setBgImage] = useState("");
  useEffect(() => {
    fetchCMSData();
    bannerimg()
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
    const bannerimg = async () => {
            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
              );
        
              const baseUrl = res.data.imagePath;
              const courseImage = res.data.home_setting[0]?.course_image;
        
              // Full image URL
              const fullUrl = baseUrl + courseImage;
        
              setBgImage(fullUrl);
            } catch (error) {
              console.error("Error fetching banner:", error);
            }
          };
    const aboutUsItems = cmsData.filter((item) => item.type === "about_us");

    const processedItems = aboutUsItems.map((item) => {
    const fullName = item.name || "";
    const words = fullName.trim().split(" ");
    const lastWord = words.pop();
    const remaining = words.join(" ");
    return {
      ...item,
      lastWord,
      remaining,
    };
  });
  return (
    <>
      {/* {status == 1 ? ( */}
      {aboutUsItems.map((item, index) => (
        <section className="course About about_section">
          <div className="page_header"></div>
          <div className="rs-breadcrumbs breadcrumbs-overlay">
            <div className="breadcrumbs-img">
             <img src={bgImage} alt="Breadcrumbs bg" loading="lazy" />
            </div>
            <div className="breadcrumbs-text white-color">
              <h1 className="page-title">About Us</h1>
            </div>
          </div>
          <Container>
            <section className="py-60">
              <Row className="align-items-center">
                <Col
                  lg={6}
                  className="order-lg-last p-0 md-pl-3 md-pr-3 md-mb-3 order_Second"
                >
                  <motion.div
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                  >
                    <div className="img-part">
                      <img
                      src={
                        item?.image ? `${imagePath}${item.image}` : ''
                      }
                      alt="About section"
                      className="img-fluid rounded about_img"
                    />
                    </div>
                  </motion.div>
                </Col>

                <Col lg={6} className="pr-lg-5 md-pr-3">
                  <div className="sec-title">
                     <h6 class="color-primary mb-8">–––– About Us</h6>
                     {processedItems.map((item, index) => (
                      <h2 key={index} className="title mb-3">
                        {item.remaining}{" "}
                        {item.lastWord && (
                          <span className="fm-sec">{item.lastWord}</span>
                        )}
                      </h2>
                    ))}
                    {/* <h2 className="title mb-3">
                      Welcome to {""}
                      <span class="fm-sec">The Excellers</span>
                    </h2> */}
                    <div className="bold-text mb-4">
                     <p  dangerouslySetInnerHTML={{ __html: item.description }}></p>
                    </div>
                   
                  </div>
                </Col>
              </Row>
            </section>
          </Container>
          {/* <section className="py-60 bg-light">
          <Container>
            <Row className="align-items-center">
              <h2 className="title mb-3 text-center">What Sets Us Apart</h2>
              <Col lg={6} className="p-0 md-pl-3 md-pr-3 md-mb-3">
                <div className="course_detail ">
                  <div className="tab-content">
                    <div className="overview">
                      <ul class="unstyled points">
                        <li class="mb-8">
                          <HiBadgeCheck />
                          <p>Affordable Coaching, Premium Learning</p>
                        </li>
                        <li class="mb-8">
                          <HiBadgeCheck />
                          <p>Experienced & Supportive Faculty</p>
                        </li>
                        <li class="mb-8">
                          <HiBadgeCheck />
                          <p>Updated Study Material & Regular Tests</p>
                        </li>
                        <li class="mb-8">
                          <HiBadgeCheck />
                          <p>Personalized Mentorship</p>
                        </li>
                        <li class="mb-8">
                          <HiBadgeCheck />
                          <p>Focused on Results, Rooted in Values</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg={6} className="pr-lg-5 md-pr-3">
                <div className="sec-title">
                  <div className="bold-text mb-4">
                    Whether you're aiming for a national law university or
                    seeking conceptual clarity in legal subjects, The Excellers
                    is your trusted academic partner. We believe in nurturing
                    potential, building strong legal foundations, and shaping
                    future changemakers.
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
        </section>
      ))}
      {/* ) : (
        ""
      )} */}
    </>
  );
};

export default AboutUs;
